import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import { getApi, postApi } from "../../utils/api";
import {
  API_ROLE_MAPPING,
  API_ROLE_MAPPING_USER,
  GET_EMPLOYEE_LIST,
} from "../../config/Endpoints";
import Cookies from "js-cookie";
import { TailSpin } from "react-loader-spinner";
import { toggleMenu } from "../../utils/helpers";
import { toast } from "react-toastify";
import Footer from "../../components/Footer";
import PageTitle from "../../components/PageTitle";

const RoleAssignmentToEmp = ({ title, description }) => {
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [selectedRoleselect, setSelectedRoleSelect] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);

  const [roleList, setRoleList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState();

  const [menuList, setMenuList] = useState([]);
  const accessToken = Cookies.get("accessToken");
  const [checkedItems, setCheckedItems] = useState({});

  useEffect(() => {
    fetchList();
  }, []);

  const fetchList = () => {
    setIsLoading(true);
    getApi(GET_EMPLOYEE_LIST, accessToken)
      .then((res) => {
        if (res.status === 200) {
          setEmployeeList(res.data.data);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };

  const optionList = employeeList?.map((item) => ({
    value: item.id,
    label: item.empName,
    type: item.employeeType,
  }));
  const Option = (props) => {
    const { data } = props;
    const { label, type } = data;

    return (
      <components.Option {...props}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>{label}</span>
          <span style={{ fontSize: "12px", color: "gray" }}>({type})</span>
        </div>
      </components.Option>
    );
  };

  const handleChangeEmployeeType = async (e) => {
    setSelectedEmployeeId(e.value);
    setCheckedItems({});
    setIsUpdated(false);

    setRoleList([]);
    setSelectedEmployee(e);
    if (e.value === "") {
      setRoleList([]);
      setIsLoading(false);
    } else {
      setIsLoading(true);
      await getApi(API_ROLE_MAPPING_USER + `/${e.value}`, accessToken)
        .then((res) => {
          if (res.status === 200) {
            setRoleList(res.data.data);
            const roleItems = res.data.data;
            const updatedCheckedItems = {};
            // Iterate through menuItems
            roleItems.forEach((item) => {
              if (item.assigned) {
                updatedCheckedItems[item.roleId] = true;
              }
            });
            // Update the checkedItems state
            setCheckedItems(updatedCheckedItems);
          } else {
            setCheckedItems({});
          }
          setIsLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    }
  };

  const handleReset = () => {
    setSelectedEmployeeId("");
    setCheckedItems({});
    setRoleList([]);
    setSelectedEmployee("");
  };

  function transformCheckedItems(checkedItems) {
    const result = [];
    for (const [id, checked] of Object.entries(checkedItems)) {
      if (checked) {
        result.push({ id: parseInt(id), operation: "assign" });
      } else {
        result.push({ id: parseInt(id), operation: "remove" });
      }
    }
    return result;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const transformedArray = transformCheckedItems(checkedItems);

      let requestObj = {
        userId: selectedEmployeeId,
        roleList: transformedArray,
      };

      await postApi(API_ROLE_MAPPING, requestObj, accessToken)
        .then((res) => {
          setIsLoading(false);
          // handleReset();
          toast.success("Successfully Updated.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsUpdated(true);
        })
        .catch((e) => {
          setIsLoading(false);
          toast.error(e.response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error("Something went wrong. Please try again!", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setIsLoading(false);
    }
  };

  // Handler for checkbox changes
  const handleCheckboxChange = (e, itemName) => {
    let id = e.target.value;
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [id]: !prevCheckedItems[itemName],
    }));
  };

  return (
    <div className="wrapper-body">
      {isLoading && (
        <div className="overlay">
          <div className="loader-container">
            <TailSpin
              height="100"
              width="100"
              radius="1"
              color="blue"
              ariaLabel="tail-spin-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        </div>
      )}

      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
      </div>
      <div className="card">
        <form id="assign-asset">
          <h3 className="heading">Employee</h3>
          <div className="inputs">
            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <div className="dropdown-container">
                  <Select
                    options={optionList}
                    components={{ Option }}
                    onChange={handleChangeEmployeeType}
                    value={selectedEmployee}
                    placeholder="Select employee"
                    isSearchable={true}
                    isDisabled={employeeList?.length === 0}
                    isRequired={true}
                  />
                </div>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div>
        </form>

        {roleList?.length > 0 && (
          <form
            id="assign-asset d-flex"
            className="mt-5"
            onSubmit={handleSubmit}
          >
            <div className="inputs">
              {roleList?.map((menuItem, index) => (
                <div key={index} className="row">
                  <div className="col-md-4"></div>
                  <div className="col-md-4">
                    {/* Main Menu Checkbox */}
                    <input
                      type="checkbox"
                      id={`check_${menuItem.name.replace(/\s+/g, "")}`}
                      checked={checkedItems[menuItem.roleId]}
                      value={menuItem.roleId}
                      onChange={(e) => handleCheckboxChange(e, menuItem.roleId)}
                      disabled={menuItem.name === "EMPLOYEE"}
                    />
                    <label
                      htmlFor={`check_${menuItem.name.replace(/\s+/g, "")}`}
                      className="mx-3"
                    >
                      {menuItem.name}
                    </label>

                    {/* Submenu Checkboxes */}
                    {/* <div className="ms-4">
                      {menuItem?.subMenu?.map((submenu, submenuIndex) => (
                        <div key={submenuIndex}>
                          <input
                            type="checkbox"
                            id={`check_${submenu.name.replace(/\s+/g, "")}`}
                            checked={checkedItems[submenu.name]}
                            value={submenu.id}
                            onChange={(e) =>
                              handleCheckboxChange(e, submenu.name)
                            }
                          />
                          <label
                            htmlFor={`check_${submenu.name.replace(
                              /\s+/g,
                              ""
                            )}`}
                            className="mx-3"
                          >
                            {submenu.name}
                          </label>
                        </div>
                      ))}
                    </div> */}
                  </div>
                  <div className="col-md-4"></div>
                </div>
              ))}
            </div>

            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <div className="action text-end">
                  {/* <button
                    className="btn btn-secondary"
                    type="button"
                    onClick={handleReset}
                  >
                    Reset
                  </button> */}
                  {!isUpdated && (
                    <button
                      className={
                        isLoading
                          ? "theme-button disabled ms-2 "
                          : "theme-button ms-2 "
                      }
                      type="submit"
                    >
                      Submit
                    </button>
                  )}
                </div>
                {isUpdated && (
                  <div className="text-center my-3 fs-1">
                    <span className="badge badge-success fs-5">
                      <strong>
                        {" "}
                        The role has been successfully assigned to{" "}
                        {selectedEmployee.label} .
                      </strong>
                    </span>
                  </div>
                )}
              </div>
              <div className="col-md-3"></div>
            </div>
          </form>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default RoleAssignmentToEmp;
